module.exports = __webpack_public_path__ + "media/promo/panasonic/images/buy-1-0eac0f916e825a2ff4e63d9d680eaac5.png";